import React, { useState, useEffect } from 'react';

import { TmCart, TmCartLine } from '@/tscapi/model/cart';
import { Storage } from '@/tscapi/utils/browser-storage';
import { Cookie } from '@/tscapi/utils/cookie';

export const useCartData = (data: TmCart) => {
    const [donationProduct, setDonationProduct] = useState<TmCartLine>(null);
    const [showSummaryDetails, setShowSummaryDetails] = useState(false);
    const [isPickup, setIsPickup] = useState(false);

    useEffect(() => {
        const storage: Storage = new Storage();
        const cookie: Cookie = new Cookie();

        // Find donation product data
        const donationProduct = data?.CartLines?.find((item) => item?.CartLineItem?.IsDonation);
        if (donationProduct) {
            setDonationProduct(donationProduct);
        } else {
            setDonationProduct(null);
        }

        // Determine if shipcode is pickup
        setIsPickup(data?.ShipCode == '35' || data?.ShipCode == '07' || data?.ShipCode == '41');

        // Determine if Order Summary should be hidden
        if (data?.CartLines === undefined || data?.CartLines?.length == 0) {
            setShowSummaryDetails(false);
        }
        if (data?.CartLines?.length >= 1) {
            setShowSummaryDetails(true);
        }
        if (data?.CartLines?.length == 1 && donationProduct) {
            // Only one product in cart but it's a donation item, therefore hide extra summary details
            setShowSummaryDetails(false);
        }
        if (cookie.ModifyOrderNumber) {
            setShowSummaryDetails(true);
        }

        // Save copy of cart in session (outside of ReactQuery, necessary for analytics)
        // Emit shopping cart ready event - used for product recommendation
        if (data) {
            storage.setSessionCart(data);
            if (data && data.Products !== undefined) {
                const cartEvent = new CustomEvent('cart-ready', { detail: { cart: data } });
                document.dispatchEvent(cartEvent);
            }
        }

        // Update cookieCartGuid
        if (data && data?.CartGuid) {
            if (cookie.CartGuid == null) {
                cookie.CartGuid = data.CartGuid;
            }
            if (cookie.CartGuid != data.CartGuid) {
                cookie.CartGuid = data.CartGuid;
            }
        }
    }, [data]);

    return { donationProduct, showSummaryDetails, isPickup };
};
